export const FIRST_NAME_REGEX = /^[A-Za-z][A-Za-z_  ]{0,29}$/
export const LAST_NAME_REGEX = /^[A-Za-z][A-Za-z_  ]{0,29}$/;
